import { FeatureNote } from './feature-note';
import { HelpDocument } from './help-document';

export interface ReleaseNote {
  releaseNoteId: string;
  applicationId: string;
  applicationName: string;
  releaseVersionNumber: string;
  releaseOverview: string;
  releaseDate: Date;
  lastUpdated: Date;
  updatedBy: string;
  releaseType: string;
  releaseTypeId: string;
  featureNotes: FeatureNote[];
  bPublished: boolean;
  bForcePopup: boolean;
  documents: HelpDocument[];
  documentsLocation?: string;
}
